module.exports = "<h1 mat-dialog-title>Link to device</h1>\n<div mat-dialog-content>\n  <mat-form-field>\n    <input matInput type=\"number\" [(ngModel)]=\"device_id\">\n  </mat-form-field>\n</div>\n<div mat-dialog-actions>\n  <button mat-button (click)=\"onNoClick()\">Cancel</button>\n  <button mat-button [mat-dialog-close]=\"device_id\" cdkFocusInitial>Link</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/link-device-dialog/link-device-dialog.component.html
// module id = ./src/app/link-device-dialog/link-device-dialog.component.html
// module chunks = main